import React from 'react'
import EventList from './EventList'
import { GetAllEventList } from '@manow/service/dist/event'
import { useObservable } from 'rxjs-hooks'
import { IonSpinner } from '@ionic/react'

interface Props {
  
}

const UpcomingEventList: React.FC<Props> = () => {
  const eventList = useObservable(() => GetAllEventList(10, ref => ref.where('Privacy', '==', 'Public').orderBy('EventStartDate', 'asc').where('EventStartDate', '>', new Date(Date.now()))))
  if (!eventList) {
    return <IonSpinner />
  }
  return (
    <EventList title="กิจกรรมที่กำลังจะเกิดขึ้น" events={eventList}/>
  )
}

export default UpcomingEventList
